
import {
  LayoutDashboardIcon,
  UsersIcon,
  CalendarClockIcon,
  AmbulanceIcon,
  BedDoubleIcon,
  ClipboardPlusIcon,
  StethoscopeIcon,
  PillIcon,
  FlaskConicalIcon,
  ScanLineIcon,
  HeartPulseIcon,
  ScissorsIcon,
  ClipboardCheckIcon,
  ReceiptTextIcon,
  WalletIcon,
  FolderTreeIcon,
  FileTextIcon,
  CalendarCheck2Icon,
  BriefcaseMedicalIcon,
  PackageIcon,
  MicroscopeIcon,
  type LucideIcon,
} from 'lucide-react'

export interface NavItem {
  label: string
  to: string
  icon: LucideIcon
  badge?: string
  badgeTone?: 'danger' | 'brand' | 'warning'
}

export interface NavGroup {
  title: string
  items: NavItem[]
}

export const navGroups: NavGroup[] = [
  {
    title: 'Executive command',
    items: [
      { label: 'Executive Dashboard', to: '/', icon: LayoutDashboardIcon },
    ],
  },
  {
    title: 'Care delivery',
    items: [
      { label: 'Patients (MPI)', to: '/patients', icon: UsersIcon },
      { label: 'Emergency Operations', to: '/emergency', icon: AmbulanceIcon, badge: '4', badgeTone: 'danger' },
      { label: 'IPD & Bed Management', to: '/beds', icon: BedDoubleIcon },
      { label: 'OPD Consultation', to: '/opd', icon: StethoscopeIcon },
      { label: 'Appointments', to: '/appointments', icon: CalendarClockIcon },
      { label: 'Reception · New Encounter', to: '/reception/encounter', icon: ClipboardPlusIcon },
      { label: 'New Admission', to: '/admissions/new', icon: BedDoubleIcon },
    ],
  },
  {
    title: 'Clinical services',
    items: [
      { label: 'Pharmacy', to: '/pharmacy', icon: PillIcon, badge: '12', badgeTone: 'warning' },
      { label: 'Laboratory', to: '/lab', icon: FlaskConicalIcon },
      { label: 'Radiology', to: '/radiology', icon: ScanLineIcon },
      { label: 'Cardiology Reporting', to: '/cardiology', icon: HeartPulseIcon, badge: '1', badgeTone: 'danger' },
    ],
  },
  {
    title: 'Operation theatre',
    items: [
      { label: 'OT Command', to: '/ot', icon: ScissorsIcon, badge: '2', badgeTone: 'warning' },
      { label: 'OT Schedule', to: '/ot/schedule', icon: CalendarClockIcon },
    ],
  },
  {
    title: 'Inpatient nursing',
    items: [
      { label: 'Nursing Station', to: '/nursing', icon: ClipboardCheckIcon, badge: '3', badgeTone: 'warning' },
    ],
  },
  {
    title: 'Patient billing',
    items: [
      { label: 'Billing & Invoices', to: '/billing', icon: ReceiptTextIcon, badge: '6', badgeTone: 'warning' },
    ],
  },
  {
    title: 'Business operations',
    items: [
      { label: 'Finance Dashboard', to: '/finance', icon: WalletIcon },
      { label: 'Chart of Accounts', to: '/finance/chart-of-accounts', icon: FolderTreeIcon },
      { label: 'Journal Vouchers', to: '/finance/vouchers', icon: FileTextIcon, badge: '2', badgeTone: 'warning' },
      { label: 'Financial Reports', to: '/finance/reports', icon: FileTextIcon },
      { label: 'Fiscal Year Control', to: '/finance/fiscal-year', icon: CalendarCheck2Icon },
      { label: 'HR & Workforce', to: '/hr', icon: BriefcaseMedicalIcon, badge: '12', badgeTone: 'warning' },
      { label: 'Inventory & Procurement', to: '/inventory', icon: PackageIcon, badge: '9', badgeTone: 'danger' },
      { label: 'Research Data Warehouse', to: '/research', icon: MicroscopeIcon },
    ],
  },
  {
    title: 'Clinical configuration',
    items: [
      { label: 'Provider & Doctor Setup', to: '/doctors/setup', icon: StethoscopeIcon },
    ],
  },
]

